<!--
 * @Description: 首页
 * @Author: yingbin
 * @Date: 2019-08-27 14:42:33
 * @LastEditTime: 2019-10-09 11:13:04
 * @LastEditors: yingbin
 -->
<template>
  <div class="home">
    <v-header></v-header>
    <div class="emptyheader"></div>
    <div class="container">
      <div class="menu-left">
        <div class="avatar">
          <img src="@/assets/images/user_avatar.png" alt="">
        </div>
        <div class="user_info">
          <div class="username">{{ userInfo.userName }}</div>
        </div>
        <div class="menus">
          <div @click="toLink('/account/userInfo')" :class="$route.path == '/account/userInfo' ? 'active' : ''" class="menu">我的账号</div>
          <div @click="toLink('/account/company')" :class="$route.path == '/account/company' ? 'active' : ''" class="menu">企业认证</div>
        </div>
      </div>
      <div class="main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../layout/components/header";
import userApi from '@/apis/user_apis.js';
export default {
  data() {
    return {
      userInfo:{},
      isFirstEdit:true,
      needEdit:true,
    };
  },
  created(){
    // this.getUserInfo()
  },
  mounted() {},
  methods: {
    /** 跳转 */
    toLink(path){
      this.$router.push(path)
    },

    /** 获取用户信息 */
    getUserInfo(){
      userApi.getUserInfo(this).then(res => {
        if(res.success){
          this.userInfo = res.data;
        }
      })
    },
    /**编辑用户名字 */
    editInfo(){
      this.isFirstEdit=false;
    },
    /**确认修改用户名称 */
    insureEdit(){
       this.isFirstEdit=true;
       this.needEdit=false;
    }
  },
  components: {
    "v-header": Header,
  }
};
</script>
<style lang="less" scoped>
.home {
  min-height: 100vh;
  background: #f7f6f5;

  .container {
    padding: 20px;
    display: flex;
    justify-content: space-between;

    .menu-left {
      width: 256px;
      min-height: 761px;
      background: #fff;
      border-radius: 8px 0 0 8px;

      .avatar {
        padding: 60px 0 0;
        text-align: center;

        img {
          width: 100px;
          height: 100px;
        }
      }

      .user_info {
        text-align: center;

        .username {
          margin-top: 10px;
          font-size: 14px;
          font-weight: 500;
          color: #303030;
          .el-icon-edit {
            margin-left: 5px;
            cursor: pointer;
            font-size: 20px;
          }
          /deep/ .el-input {
            width: 200px;
          }
        }
        .firstHint {
          color:red;
          font-size: 12px;;
          margin-top: 8px;
        }

        .signature {
          font-size: 12px;
          color: #bfbfbf;
          padding: 10px 0 20px;
        }

        .btn {
          > div {
            width: 100px;
            height: 30px;
            margin: 0 auto;
            border-radius: 2px;
            border: 1px solid #fabe00;
            color: #fabe00;
            line-height: 30px;
            font-size: 14px;
            -moz-user-select: none; /*火狐*/
            -webkit-user-select: none; /*webkit浏览器*/
            -ms-user-select: none; /*IE10*/
            -khtml-user-select: none; /*早期浏览器*/
            user-select: none;
            cursor: pointer;
          }
        }
      }

      .menus{
        margin-top: 100px;

        .menu{
          cursor: pointer;
          height: 60px;
          color: #333333;
          font-size: 14px;
          line-height: 60px;
          text-align: center;

          &:hover{
            opacity: 0.6;
          }
        }

        .active{
          background: #FAFAFA;
          font-weight: 500;
          position: relative;

          &::after{
            content:"";
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 5px;
            background: #FABE00;
          }
        }
      }
    }

    .main{
      width: 925px;
      background: #fff;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
}
</style>